import styled from "styled-components";

export const FormContainer = styled.div`
    padding-right:50px;
    padding-left:50px;
    padding-top:20px;
    max-width:450px
`